/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { RouteSchedulesResponse } from '@/client/models';
// @ts-ignore
import type { StopSchedulesResponse } from '@/client/models';
// @ts-ignore
import type { TerminusSchedulesResponse } from '@/client/models';
/**
 * SchedulesApi - axios parameter creator
 */
export const SchedulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get terminus schedules for a specific line and stop area
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} physicalMode Physical mode ID
         * @param {string} line Line ID
         * @param {string} stopArea Stop area ID
         * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet: async (coverage: string, physicalMode: string, line: string, stopArea: string, fromDatetime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet', 'coverage', coverage)
            // verify required parameter 'physicalMode' is not null or undefined
            assertParamExists('coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet', 'physicalMode', physicalMode)
            // verify required parameter 'line' is not null or undefined
            assertParamExists('coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet', 'line', line)
            // verify required parameter 'stopArea' is not null or undefined
            assertParamExists('coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet', 'stopArea', stopArea)
            const localVarPath = `/coverage/{coverage}/physical_modes/{physical_mode}/lines/{line}/stop_areas/{stop_area}/terminus_schedules`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"physical_mode"}}`, encodeURIComponent(String(physicalMode)))
                .replace(`{${"line"}}`, encodeURIComponent(String(line)))
                .replace(`{${"stop_area"}}`, encodeURIComponent(String(stopArea)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fromDatetime !== undefined) {
                localVarQueryParameter['from_datetime'] = fromDatetime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get route schedules
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter Filter (e.g., \&#39;line.id&#x3D;xxx\&#39;)
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageRouteSchedulesGet: async (coverage: string, filter: string, datetime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageRouteSchedulesGet', 'coverage', coverage)
            // verify required parameter 'filter' is not null or undefined
            assertParamExists('coverageCoverageRouteSchedulesGet', 'filter', filter)
            const localVarPath = `/coverage/{coverage}/route_schedules`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (datetime !== undefined) {
                localVarQueryParameter['datetime'] = datetime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get route schedules for a specific route
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Route ID
         * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageRoutesIdRouteSchedulesGet: async (coverage: string, id: string, fromDatetime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageRoutesIdRouteSchedulesGet', 'coverage', coverage)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coverageCoverageRoutesIdRouteSchedulesGet', 'id', id)
            const localVarPath = `/coverage/{coverage}/routes/{id}/route_schedules`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fromDatetime !== undefined) {
                localVarQueryParameter['from_datetime'] = fromDatetime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get stop schedules for a specific stop point
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Stop point ID
         * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopPointsIdStopSchedulesGet: async (coverage: string, id: string, fromDatetime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageStopPointsIdStopSchedulesGet', 'coverage', coverage)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coverageCoverageStopPointsIdStopSchedulesGet', 'id', id)
            const localVarPath = `/coverage/{coverage}/stop_points/{id}/stop_schedules`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fromDatetime !== undefined) {
                localVarQueryParameter['from_datetime'] = fromDatetime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get stop schedules
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter Filter (e.g., \&#39;stop_area.id&#x3D;xxx\&#39;)
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopSchedulesGet: async (coverage: string, filter: string, datetime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageStopSchedulesGet', 'coverage', coverage)
            // verify required parameter 'filter' is not null or undefined
            assertParamExists('coverageCoverageStopSchedulesGet', 'filter', filter)
            const localVarPath = `/coverage/{coverage}/stop_schedules`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (datetime !== undefined) {
                localVarQueryParameter['datetime'] = datetime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get terminus schedules
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter Filter
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageTerminusSchedulesGet: async (coverage: string, filter: string, datetime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageTerminusSchedulesGet', 'coverage', coverage)
            // verify required parameter 'filter' is not null or undefined
            assertParamExists('coverageCoverageTerminusSchedulesGet', 'filter', filter)
            const localVarPath = `/coverage/{coverage}/terminus_schedules`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (datetime !== undefined) {
                localVarQueryParameter['datetime'] = datetime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchedulesApi - functional programming interface
 */
export const SchedulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchedulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get terminus schedules for a specific line and stop area
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} physicalMode Physical mode ID
         * @param {string} line Line ID
         * @param {string} stopArea Stop area ID
         * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet(coverage: string, physicalMode: string, line: string, stopArea: string, fromDatetime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerminusSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet(coverage, physicalMode, line, stopArea, fromDatetime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulesApi.coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get route schedules
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter Filter (e.g., \&#39;line.id&#x3D;xxx\&#39;)
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageRouteSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageRouteSchedulesGet(coverage, filter, datetime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulesApi.coverageCoverageRouteSchedulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get route schedules for a specific route
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Route ID
         * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageRoutesIdRouteSchedulesGet(coverage: string, id: string, fromDatetime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageRoutesIdRouteSchedulesGet(coverage, id, fromDatetime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulesApi.coverageCoverageRoutesIdRouteSchedulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get stop schedules for a specific stop point
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Stop point ID
         * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageStopPointsIdStopSchedulesGet(coverage: string, id: string, fromDatetime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StopSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageStopPointsIdStopSchedulesGet(coverage, id, fromDatetime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulesApi.coverageCoverageStopPointsIdStopSchedulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get stop schedules
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter Filter (e.g., \&#39;stop_area.id&#x3D;xxx\&#39;)
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageStopSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StopSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageStopSchedulesGet(coverage, filter, datetime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulesApi.coverageCoverageStopSchedulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get terminus schedules
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter Filter
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageTerminusSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerminusSchedulesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageTerminusSchedulesGet(coverage, filter, datetime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SchedulesApi.coverageCoverageTerminusSchedulesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SchedulesApi - factory interface
 */
export const SchedulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchedulesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get terminus schedules for a specific line and stop area
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} physicalMode Physical mode ID
         * @param {string} line Line ID
         * @param {string} stopArea Stop area ID
         * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet(coverage: string, physicalMode: string, line: string, stopArea: string, fromDatetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<TerminusSchedulesResponse> {
            return localVarFp.coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet(coverage, physicalMode, line, stopArea, fromDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get route schedules
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter Filter (e.g., \&#39;line.id&#x3D;xxx\&#39;)
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageRouteSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<RouteSchedulesResponse> {
            return localVarFp.coverageCoverageRouteSchedulesGet(coverage, filter, datetime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get route schedules for a specific route
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Route ID
         * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageRoutesIdRouteSchedulesGet(coverage: string, id: string, fromDatetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<RouteSchedulesResponse> {
            return localVarFp.coverageCoverageRoutesIdRouteSchedulesGet(coverage, id, fromDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get stop schedules for a specific stop point
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id Stop point ID
         * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopPointsIdStopSchedulesGet(coverage: string, id: string, fromDatetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<StopSchedulesResponse> {
            return localVarFp.coverageCoverageStopPointsIdStopSchedulesGet(coverage, id, fromDatetime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get stop schedules
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter Filter (e.g., \&#39;stop_area.id&#x3D;xxx\&#39;)
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<StopSchedulesResponse> {
            return localVarFp.coverageCoverageStopSchedulesGet(coverage, filter, datetime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get terminus schedules
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} filter Filter
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageTerminusSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<TerminusSchedulesResponse> {
            return localVarFp.coverageCoverageTerminusSchedulesGet(coverage, filter, datetime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchedulesApi - interface
 */
export interface SchedulesApiInterface {
    /**
     * 
     * @summary Get terminus schedules for a specific line and stop area
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} physicalMode Physical mode ID
     * @param {string} line Line ID
     * @param {string} stopArea Stop area ID
     * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet(coverage: string, physicalMode: string, line: string, stopArea: string, fromDatetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<TerminusSchedulesResponse>;

    /**
     * 
     * @summary Get route schedules
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} filter Filter (e.g., \&#39;line.id&#x3D;xxx\&#39;)
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageRouteSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<RouteSchedulesResponse>;

    /**
     * 
     * @summary Get route schedules for a specific route
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id Route ID
     * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageRoutesIdRouteSchedulesGet(coverage: string, id: string, fromDatetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<RouteSchedulesResponse>;

    /**
     * 
     * @summary Get stop schedules for a specific stop point
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id Stop point ID
     * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageStopPointsIdStopSchedulesGet(coverage: string, id: string, fromDatetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<StopSchedulesResponse>;

    /**
     * 
     * @summary Get stop schedules
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} filter Filter (e.g., \&#39;stop_area.id&#x3D;xxx\&#39;)
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageStopSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<StopSchedulesResponse>;

    /**
     * 
     * @summary Get terminus schedules
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} filter Filter
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageTerminusSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig): AxiosPromise<TerminusSchedulesResponse>;

}

/**
 * SchedulesApi - object-oriented interface
 */
export class SchedulesApi extends BaseAPI implements SchedulesApiInterface {
    /**
     * 
     * @summary Get terminus schedules for a specific line and stop area
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} physicalMode Physical mode ID
     * @param {string} line Line ID
     * @param {string} stopArea Stop area ID
     * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet(coverage: string, physicalMode: string, line: string, stopArea: string, fromDatetime?: string, options?: RawAxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).coverageCoveragePhysicalModesPhysicalModeLinesLineStopAreasStopAreaTerminusSchedulesGet(coverage, physicalMode, line, stopArea, fromDatetime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get route schedules
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} filter Filter (e.g., \&#39;line.id&#x3D;xxx\&#39;)
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageRouteSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).coverageCoverageRouteSchedulesGet(coverage, filter, datetime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get route schedules for a specific route
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id Route ID
     * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageRoutesIdRouteSchedulesGet(coverage: string, id: string, fromDatetime?: string, options?: RawAxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).coverageCoverageRoutesIdRouteSchedulesGet(coverage, id, fromDatetime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get stop schedules for a specific stop point
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id Stop point ID
     * @param {string} [fromDatetime] From date and time (YYYYMMDDTHHmmss)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageStopPointsIdStopSchedulesGet(coverage: string, id: string, fromDatetime?: string, options?: RawAxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).coverageCoverageStopPointsIdStopSchedulesGet(coverage, id, fromDatetime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get stop schedules
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} filter Filter (e.g., \&#39;stop_area.id&#x3D;xxx\&#39;)
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageStopSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).coverageCoverageStopSchedulesGet(coverage, filter, datetime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get terminus schedules
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} filter Filter
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageTerminusSchedulesGet(coverage: string, filter: string, datetime?: string, options?: RawAxiosRequestConfig) {
        return SchedulesApiFp(this.configuration).coverageCoverageTerminusSchedulesGet(coverage, filter, datetime, options).then((request) => request(this.axios, this.basePath));
    }
}

